import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Box from '@mui/material/Box'
import './Project.css';
import logo from '../../Assets/Projects/logo.png';
import ux from '../../Assets/Projects/adwyzors_ux.png';
import ui from '../../Assets/Projects/adwyzors_ui.png';
import styleguide from '../../Assets/Projects/adwyzors_styleguide.png';
import adwyzors from '../../Assets/Projects/adwyzors.png';

import period from '../../Assets/period.svg';
import {Link} from 'react-router-dom';
import NavBar from "../Navbar";
import Footer from "../Footer";

function Adwyzors() {
  return (
    <section>
      <NavBar />
      <Box className="filebox">

            <Row>
            <aside>
              <Col sm={1}>
                <Container style={{ height: '100%' }}>
                
            <div direction="right" className="side-banner">
              <div className="marquee">
              <div className="marquee-content" style={{animationDuration: '80s' }}>
              Adwyzors          Adwyzors          Adwyzors           Adwyzors          Adwyzors          Adwyzors          Adwyzors           Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors           Adwyzors          Adwyzors          AdwyzorsAdwyzors          Adwyzors          Adwyzors           Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors           Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors                    Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors         Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors         Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors         Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors         Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors         Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors          Adwyzors          
                </div>
                </div>
                </div>
                </Container>
              </Col>
              <Col sm={10} className="canteen-ui" style={{ paddingLeft: '130px', paddingRight: '70px' }}>
              <Container fluid className="project-section">
          <Container  className="canteen-content">
                <Row className="first-img" style={{ justifyContent: "center", paddingTop: '40px', paddingBottom: "40px" }}>

                <img
                      src={adwyzors}
                      alt="ecanteen"
                      className="img-fluid"
                      style={{marginBottom: '30px', padding: '0px', border: '1px solid white'}}
                    />
                  </Row>
                  <Row style={{paddingBottom: "40px"}}>
                  <div style={{display:'flex'}}>
                  <h1>Adwyzors: A LinkedIn Redesign for CAs
                  <img
                    src={period}
                    alt="period"
                    className="img-fluid"
                    style={{marginLeft: '2px', paddingTop: '2.5%', }}
                  />
                  </h1>
                  
                  </div>
                  <p className="content">Adwyzors is a platform solely for Chartered Accountants and related field professionals to network on the internet. A place that allows o find the right job or internship, connect and strengthen professional relationships, and learn the skills you need to succeed in your career. </p>
                  </Row>
                <Row style={{paddingBottom: "56px", fontFamily: 'Changa', fontSize: '1.2em'}} >
                    <Col sm={4} className="box-col">
                    <div style={{border: "1px solid white", padding: '5%', height: '100%' }}>
                    <p className="box-head">MY ROLE</p>
                    <p className="box-p">Product Designer</p>
                    </div>
                    </Col>
                    
                    
                    <Col sm={4} className="box-col">
                    <div style={{border: "1px solid white", padding: '5%', height: '100%' }}>
                    <p className="box-head">TIMELINE</p>
                    <p className="box-p">1 week</p>
                    </div>
                    </Col>
                    <Col sm={4} className="box-col">
                    <div style={{border: "1px solid white", padding: '5%', height: '100%' }}>
                    <p className="box-head">TOOLS USED</p>
                    <p className="box-p">Figma</p>
                    </div>
                    </Col>
                    {/* <Col className="box-col">
                    <div style={{border: "1px solid white", padding: '5%', height: '100%' }}>
                    <p className="content">PUBLICATIONS</p>
                    <p className="content">Figma, HTML/CSS, Django, Firebase, Flutter</p>
                    </div>
                    </Col> */}
                </Row>
                <Row style={{paddingBottom: "40px"}}>
                    <Col>
                    <hr></hr>
                    <Row>
                    <div style={{display:'flex'}}>
                      <h2> THE BRIEF</h2> 
                    <img
                      src={period}
                      alt="period"
                      className="img-fluid"
                      style={{marginLeft: '2px', paddingBottom: '2.5%', verticalAlign: 'bottom' }}
                    />
                    </div>
                    </Row>
                    <h5>OVERVIEW</h5>
                    <p className="content">I was approached to help developers design a platform which would essentially be a "LinkedIn" for Chartered Accountants. Since they had the base system ready, I had to stick to the functionality plan they had already mapped out.</p>
                    </Col>
                </Row>
                {/* <Row style={{paddingBottom: "40px", }}>
                <img
                      src={process}
                      alt="process"
                      className="img-fluid"
                      style={{ maxHeight: "300px" }}
                    />
                    </Row> */}
                
                    <Row style={{paddingBottom: "40px"}}>
                    <Col>
                    <hr></hr>
                    <div  style={{display: 'flex'}}>
                      <h2 style={{display: 'flex'}}>LOGO DESIGN</h2> 
                      <img
                      src={period}
                      alt="period"
                      className="img-fluid"
                      style={{ justifyItems: 'start', margin: '2px', paddingBottom: '2.5%', verticalAlign: 'bottom' }}
                    />
                    </div>
                    <div>
                    <img
                      src={logo}
                      alt="Logo"
                      className="img-fluid"
                    />
                    </div>
                                        
                    </Col>
                </Row>

                <Row style={{paddingBottom:"32px"}}>
                  <Col>
                    
                    <hr></hr>
                    <div style={{display: 'flex'}}>
                    <h2>SOLUTION
                    <img
                      src={period}
                      alt="period"
                      className="img-fluid"
                      style={{marginLeft: '2px', paddingBottom: '5%', verticalAlign: 'bottom' }}
                    /></h2>
                    </div>

                    <div  style={{paddingBottom:"64px"}}>
                    <h4>LOW FIDELITY DESIGN:</h4>
                    <img
                      src={ux}
                      alt="User Experience Design"
                      className="img-fluid"

                    />
                    </div>

                    <div  style={{paddingBottom:"64px"}}>
                    <h4>STYLE GUIDE:</h4>
                    <img
                      src={styleguide}
                      alt="styleguide"
                      className="img-fluid"

                    />
                    </div>

                    <div  style={{paddingBottom:"32px"}}>
                    <h4>HIGH FIDELITY DESIGN:</h4>
                    <img
                      src={ui}
                      alt="User Interface Design"
                      className="img-fluid"
                    />
                    </div>
                    
                    
                  </Col>
                </Row>

                 
                <Row style={{marginBottom: "100px", paddingTop:"40px", fontFamily: 'Changa', fontSize: '1.2em'}}>
                  <Link to={'/project/ecommerce'} style={{textDecoration: 'none'}}>
                    <div className="button-work" style={{border: "1px solid white",borderRadius:'5px', height: 'auto', width: '15%',color:'white', textAlign: 'center', verticalAlign: 'center', paddingTop: '10px', paddingBottom:'10px', position: 'absolute'}}>
                    Previous
                    </div>
                  </Link>
                  <Link to={'/project/ecanteen'} style={{textDecoration: 'none'}}>
                    <div className="button-work" style={{border: "1px solid white",borderRadius:'5px', height: 'auto', width: '15%',color:'white', textAlign: 'center', verticalAlign: 'center', paddingTop: '10px', paddingBottom:'10px', position: 'absolute', right:'0px'}}>
                    Next
                    </div>
                  </Link>
                </Row> 
                </Container>
        </Container>
              </Col>
              </aside>
            </Row>
         
        <Footer />
      </Box>
    </section>
  );
}

export default Adwyzors;
